import { StaticQuery, graphql } from "gatsby";
import React from "react";

import { Image } from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

// import SolarPanel from "images/solar_panel.png";

import { PowerMove as PowerMoveContent } from "components/PowerMove";

export const PowerMove = () => (
  <PowerMoveContent>
    <StaticQuery
      query={graphql`
        query PowerMoveIndexHeroImageQuery {
          file(relativePath: { eq: "solar_panel.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          alt=""
          file={file}
          css={`
            + picture > img,
            img {
              object-position: 12% center;
              @media screen and (min-width: ${getSize("tablet720")}) {
                object-position: 30% center;
              }
            }
          `}
        />
      )}
    />
  </PowerMoveContent>
);
